module.exports = __webpack_public_path__ + "assets/images/balendar.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/balendar.png
// module id = 1492
// module chunks = 1